import { render, staticRenderFns } from "./eventCloseStatis.vue?vue&type=template&id=4f749144&scoped=true&"
import script from "./eventCloseStatis.vue?vue&type=script&lang=js&"
export * from "./eventCloseStatis.vue?vue&type=script&lang=js&"
import style0 from "./eventCloseStatis.vue?vue&type=style&index=0&id=4f749144&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f749144",
  null
  
)

export default component.exports